import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { UtilisateurService } from './utilisateur.service';


@Injectable()
export class AuthGuardService {

  constructor(
    private authService: AuthService,
    private utilisateurService: UtilisateurService,
    private router: Router) { }


  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const isAuthenticated = await this.authService.checkAuthentication();

    if (!isAuthenticated) {
      const targetUrl = state.url;
      if (targetUrl && targetUrl.endsWith('/aide-et-soutien')) {
        sessionStorage.setItem('redirectUrl', targetUrl);
      }
      this.authService.startAuthentication();
      return false;
    }

    const targetUrl = state.url;
    if (targetUrl && (targetUrl.endsWith('/accueil') || targetUrl.endsWith('/selection-entite'))) {
      return new Promise((resolve) => {
        this.utilisateurService.obtenirStatutCCAQ(this.authService.User!.profile.sub).pipe(
          map((statutCCAQ) => {
            if (statutCCAQ.estCCAQ && !statutCCAQ.estAdminCCAQ) {
              this.authService.logoutToLogin();
              return false;
            }
            return true;
          }),
          catchError(() => {
            return of(true);
          })
        ).subscribe(result => resolve(result));
      });
    }

    return true;
  }
}
